module.exports = __webpack_public_path__ + "static/img/sox2.22915e9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/furnitures/sox2.jpg
// module id = VMQ8
// module chunks = 0